import React, { useContext, useEffect } from 'react';
import { useTranslation } from "react-i18next";

import { EnvGet } from '../../utils/EnvGet';
import BankingTypeContext from '../../utils/BankingType/context';
import { masthead } from './data/masthead.json';
import { compileDisclosureText } from '../../utils/SiteTools';
import * as SELECTORS from '../../constants/selectors';
import './Masthead.scss';

/**
 * Masthead component
 * Shows the H1 Tag of the subpage with a specific background for each scenario
 * @param selectorKey - The name of the page to decide which title and background to show
 */
const Masthead = ({ selectorKey, content }) => {

    const { t, i18n } = useTranslation('masthead');
    const pageMasthead = masthead[selectorKey];
    const sourceName = EnvGet();
    const { bankingType } = useContext(BankingTypeContext);
    const currentLang = content.lang;

/* This is a React Hook that is used to set the document title. */
    useEffect(() => {
      document.title =
        selectorKey === 'home' ? t(pageMasthead.title) : content.name;
    }, [content.name, t, pageMasthead, selectorKey]);

    useEffect(() => {
        currentLang === 'en' ? i18n.changeLanguage('en') : i18n.changeLanguage('es');
    }, [currentLang, i18n]);

    return (
        <section id="masthead" className="content_wrapper masthead" data-action="masthead">
            <div className="masthead__wrapper">
                { selectorKey !== 'home'
                    && (bankingType === SELECTORS.OLB
                        ? <p className="masthead__category--type" dangerouslySetInnerHTML={{ __html: t("masthead.olbText") }}></p>
                        : bankingType === SELECTORS.MPOS ? <p className="masthead__category--type" dangerouslySetInnerHTML={{ __html: t("masthead.mposText") }}></p>
                        : bankingType === SELECTORS.ESSENTIALS ? <p className="masthead__category--type" dangerouslySetInnerHTML={{ __html: t("masthead.essentialsText") }}></p>
                        : bankingType === SELECTORS.RESTAURANT ? <p className="masthead__category--type" dangerouslySetInnerHTML={{ __html: t("masthead.restaurantText") }}></p>
                        : bankingType === SELECTORS.RETAIL ? <p className="masthead__category--type" dangerouslySetInnerHTML={{ __html: t("masthead.retailText") }}></p>
                        : <p className="masthead__category--type" dangerouslySetInnerHTML={{ __html: t("masthead.mbText") }}></p>
                    )
                }
                { selectorKey === 'home'
                    ? <h1 className="masthead__category--title" dangerouslySetInnerHTML={{ __html: content.copyMasthead }}></h1>
                    : <h1 className="masthead__category--title" dangerouslySetInnerHTML={{ __html: content.name }}></h1>
                }
                
                { selectorKey !== 'home' && <div className="masthead__category--copy" dangerouslySetInnerHTML={{ __html: compileDisclosureText(content.copy).join('') }}></div> }
            </div>

            { selectorKey === 'home'
                ?   <div className="bground-image-wrapper">
                        <img src={`${sourceName}${content.imgMasthead.mobile}`} alt={content.imgMasthead.altText ? content.imgMasthead.altText : ''} className="img-mobile" />
                        <img src={`${sourceName}${content.imgMasthead.desktop}`} alt={content.imgMasthead.altText ? content.imgMasthead.altText : ''} className="img-desktop" />
                    </div>
                : bankingType === SELECTORS.OLB
                    ?   <div className="bground-image-wrapper">
                            <img src={`${sourceName}${content.imgType.olb.mobile}`} alt={content.imgType.olb.altText ? content.imgType.olb.altText : ''} className="img-mobile" />
                            <img src={`${sourceName}${content.imgType.olb.desktop}`} alt={content.imgType.olb.altText ? content.imgType.olb.altText : ''} className="img-desktop" />
                        </div>
                    : bankingType === SELECTORS.MB 
                    ?   <div className="bground-image-wrapper">
                            <img src={`${sourceName}${content.imgType.mb.mobile}`} alt={content.imgType.mb.altText ? content.imgType.mb.altText : ''} className="img-mobile" />
                            <img src={`${sourceName}${content.imgType.mb.desktop}`} alt={content.imgType.mb.altText ? content.imgType.mb.altText : ''} className="img-desktop" />
                        </div>
                    : bankingType === SELECTORS.ESSENTIALS 
                    ?   <div className="bground-image-wrapper">
                            <img src={`${sourceName}${content.imgType.essentials.mobile}`} alt={content.imgType.essentials.altText ? content.imgType.essentials.altText : ''} className="img-mobile" />
                            <img src={`${sourceName}${content.imgType.essentials.desktop}`} alt={content.imgType.essentials.altText ? content.imgType.essentials.altText : ''} className="img-desktop" />
                        </div>
                    :   <div className="bground-image-wrapper">
                            <img src={`${sourceName}${content.imgType.mpos.mobile}`} alt={content.imgType.mpos.altText ? content.imgType.mpos.altText : ''} className="img-mobile" />
                            <img src={`${sourceName}${content.imgType.mpos.desktop}`} alt={content.imgType.mpos.altText ? content.imgType.mpos.altText : ''} className="img-desktop" />
                        </div>
            }
        </section>
    );
};

export default Masthead;